<template>
  <div class="space-y-24 flex flex-col h-full">
    <div class="flex items-center justify-between min-h-48">
      <TextIcon
        icon="svguse:#icon_trophy"
        text="My Highlights"
        icon-class="text-primary-pure"
        :div-class="
          titleSmall
            ? 'text-headline-1 !gap-12 !font-normal'
            : '!gap-12 !font-normal'
        "
      />

      <q-icon
        name="svguse:#icon_info_circle"
        class="text-neutral-70 size-24 cursor-pointer"
      >
        <q-tooltip
          anchor="top middle"
          self="bottom middle"
          class="bg-neutral-100 text-white"
        >
          Destaques personalizados para o seu desempenho na Copa.
        </q-tooltip>
      </q-icon>
    </div>

    <OTable
      v-if="true"
      ref="tableRef"
      :columns="columns"
      :rows="item?.highlights"
    >
      <template #body="_props">
        <q-tr :props="_props" class="!h-[3.625rem]">
          <q-td key="rank" auto-width class="!min-w-0">
            {{ _props.row.rank }}
          </q-td>
          <q-td key="metric" auto-width>
            {{ _props.row.metric }}
          </q-td>
          <q-td key="factor" auto-width>
            {{ _props.row.fator }} {{ _props.row.fator_name }}
          </q-td>
          <q-td key="value" auto-width>
            {{ fRowValue(_props.row.value) }}
          </q-td>
          <q-td key="points" auto-width class="text-center">
            {{ _props.row.points || '-' }}
          </q-td>
        </q-tr>
      </template>
      <template #bottom />
    </OTable>

    <div
      v-else
      class="flex-1 flex flex-col items-center justify-center text-center gap-12 rounded-xl border border-dashed border-neutral-100/15 bg-neutral-100/[0.02] py-32 px-24"
    >
      <div
        class="flex items-center justify-center size-80 rounded-full bg-primary-pure/10 text-primary-pure"
      >
        <q-icon name="engineering" size="2.75rem" />
      </div>

      <p class="text-title-3 text-neutral-100">Em manutenção</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import OTable from "components/Table/OTable.vue";
import TextIcon from "components/Text/TextIcon.vue";

defineProps({
  titleSmall: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    required: true,
  },
});

const fRowValue = (v) => {
  let n = Number(v);
  if (isNaN(n)) return String(v).replace(".", ",");
  return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

const tableRef = ref(null);

const columns = [
  {
    name: "rank",
    label: "Ranking Latam",
    align: "left",
  },
  {
    name: "metric",
    label: "Metric",
    align: "left",
  },
  {
    name: "factor",
    label: "Factor",
    align: "left",
  },
  {
    name: "value",
    label: "Actual",
    align: "left",
  },
  {
    name: "points",
    label: "Points",
    align: "center",
  },
];
</script>

<style scoped lang="sass">
:deep(.q-table thead tr th)
  @apply text-headline-3 bg-[#fafafa] text-neutral-70

:deep(.q-table tbody tr td)
  @apply text-headline-3 text-neutral-100
</style>
